import React from 'react';
import PostCtaAction from './PostCtaAction';

// eslint-disable-next-line react/prop-types
const SquireInfo = ({ reservationLink, shopName, renderAction, standalone, isCustomerEmail, supportLink }) => {
  const poweredByClass = standalone ? '' : 'u-hide-on-desktop';
  return (
    <div>
      <div className="u-text-small u-co-grey u-hide-on-desktop u-mb-8">
        {renderAction({ reservationLink })}
      </div>
      <div className={poweredByClass}>
        <img
          className="u-mb-1"
          width="64px"
          src="https://squire-emails.s3-us-west-1.amazonaws.com/images/squire-powered-by.png"
          alt=""
        />
        <br />
        <img
          width="80px"
          src="https://squire-emails.s3-us-west-1.amazonaws.com/images/squire.png"
          alt=""
        />
      </div>
      <div className={`u-pt-5 ${standalone ? '' : 'u-hide-on-desktop'}`} />
      <div className="u-flex u-mb-10">
        <div className="u-1/2-medium-and-up u-text-small u-co-grey">
          Squire Technologies is a company<br />
          dedicated to making style and<br />
          grooming for men simple.
        </div>
        <div className="u-1/2 u-text-small u-co-grey u-hide-on-mobile">
          {renderAction({ reservationLink })}
        </div>
      </div>
      <div className="c-divider" />
      <div className="c-footer-info">
        <div className="u-text-tiny u-co-grey--light">
          You&apos;re receiving this email because you use Squire to<br />manage your appointments for {shopName}.
        </div>
        <a
          href={isCustomerEmail ? 'https://www.instagram.com/getsquire' : supportLink}
          className="u-flex u-align-center u-text-small u-co-grey"
          target="_blank"
          rel="noopener noreferrer"
        >
          {isCustomerEmail ? (<img width="20px" src="https://squire-emails.s3-us-west-1.amazonaws.com/images/instagram@4x.png" alt="" />) : (<img width="20px" src="https://squire-emails.s3-us-west-1.amazonaws.com/images/intercom.png" alt="" />)}
          &nbsp;&nbsp;
          <span className="u-mr-2">
            {isCustomerEmail ? 'Instagram' : 'Support'}
          </span>
        </a>
      </div>
    </div>
  );
};

SquireInfo.defaultProps = {
  renderAction: PostCtaAction,
};

export default SquireInfo;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/SquireInfo.jsx